module.exports = __webpack_public_path__ + "static/19-c43bc637c6905ed3456a3aafee492f1b.png";